import { Box, Paper, Skeleton, GridLegacy as Grid } from "@mui/material";
import { Suspense } from "react";
import { WasteFulfillmentSummaryProvider } from "../WasteFulfillmentSummaryContext";
import { Summary } from "./Summary";

function SummarySkeleton() {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Paper elevation={0} sx={{ padding: 2 }}>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Box textAlign="center">
                <Skeleton
                  variant="text"
                  width={100}
                  height={48}
                  sx={{ mx: "auto" }}
                />
                <Skeleton
                  variant="text"
                  width={120}
                  height={20}
                  sx={{ mx: "auto" }}
                />
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Box textAlign="center">
                <Skeleton
                  variant="text"
                  width={80}
                  height={48}
                  sx={{ mx: "auto" }}
                />
                <Skeleton
                  variant="text"
                  width={80}
                  height={20}
                  sx={{ mx: "auto" }}
                />
              </Box>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
      <Grid item lg={6} md={6} xs={12}>
        <Paper elevation={0} sx={{ p: 2, minHeight: 300 }}>
          <Skeleton variant="text" width={150} height={24} sx={{ mb: 2 }} />
          <Skeleton
            variant="circular"
            width={200}
            height={200}
            sx={{ mx: "auto" }}
          />
        </Paper>
      </Grid>
      <Grid item lg={6} md={6} xs={12}>
        <Paper elevation={0} sx={{ p: 2, minHeight: 300 }}>
          <Skeleton variant="text" width={150} height={24} sx={{ mb: 2 }} />
          <Skeleton
            variant="circular"
            width={200}
            height={200}
            sx={{ mx: "auto" }}
          />
        </Paper>
      </Grid>
      <Grid item lg={6} md={6} xs={12}>
        <Paper elevation={0} sx={{ p: 2, minHeight: 300 }}>
          <Skeleton variant="text" width={150} height={24} sx={{ mb: 2 }} />
          <Skeleton variant="rounded" height={200} />
        </Paper>
      </Grid>
      <Grid item lg={6} md={6} xs={12}>
        <Paper elevation={0} sx={{ p: 2, minHeight: 300 }}>
          <Skeleton variant="text" width={150} height={24} sx={{ mb: 2 }} />
          <Skeleton
            variant="circular"
            width={200}
            height={200}
            sx={{ mx: "auto" }}
          />
        </Paper>
      </Grid>
    </Grid>
  );
}

type SummaryOverviewProps = {
  defaultSearch: string;
};

/**
 * Wrapper that provides Suspense boundary and summary query context.
 * Write actions come from OmnisearchProvider context (useOmnisearch)
 * consumed directly by the Summary component — no prop drilling needed.
 */
export function SummaryOverview({ defaultSearch }: SummaryOverviewProps) {
  return (
    <Suspense fallback={<SummarySkeleton />}>
      <WasteFulfillmentSummaryProvider defaultSearch={defaultSearch}>
        <Summary />
      </WasteFulfillmentSummaryProvider>
    </Suspense>
  );
}
